import { render, staticRenderFns } from "./LinkedInLoginCard.vue?vue&type=template&id=bfb7589c"
import script from "./LinkedInLoginCard.vue?vue&type=script&lang=ts"
export * from "./LinkedInLoginCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports